export function waitAnimationFrame(cb) {
    requestAnimationFrame(() => {
        setTimeout(cb, 0)
    })
}
